"use client"
import React, { Fragment, useState, useEffect } from "react";
import Select, { components } from "react-select";
import { useAppData } from "@/lib/providers/AppDataProvider";
import ProfileTypeIcon from "@/components/shared/ProfileTypeIcon";

import "@/components/communities/CommunityDirectoryPointFilterv2.css";

import * as turf from "@turf/turf";
import ProfileTypeFilter from "@/components/categories/ProfileTypeFilter";
import AmenityFilter from "@/components/categories/AmenityFilter";
import { Collapse, Form } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import TextSearchInputField from "@/components/shared/TextSearchInputField";
import ProfileTypeFilterv2 from "@/components/categories/ProfileTypeFilterv2";

var moment = require("moment");

const CommunityDirectoryPointFilterv2 = ({
  community,
  points,
  types,
  onSelect,
  // false hides the "Open Now" toggle (e.g. embeds with openNow=false)
  showOpenNow = true
}) => {
  const isSm = useMediaQuery({ maxWidth: 767.98 });
  const [selected, setSelected] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSubtype, setSelectedSubtype] = useState(null);
  const [selectedAmenities, setSelectedAmenities] = useState(null);
  const [openNowCheck, setOpenNowCheck] = useState(false);
  const [typeGroupOptions, setTypeGroupOptions] = useState(null);
  const [amenityOptions, setAmenityOptions] = useState(null);
  const { flattenedProfileTypes: profileTypes, profileTypes: nestedProfileTypes, amenities } = useAppData();
  const [filterOptions, setFilterOptions] = useState([]);
  const [typeCounts, setTypeCounts] = useState({
    AMBASSADOR: 0,
    POI: 0,
    BUSINESS: 0,
    COMMUNITY: 0
  });
  const [textSearch, setTextSearch] = useState(null);

  const typeToLabel = {
    AMBASSADOR: "Ambassadors",
    BUSINESS: "Businesses",
    POI: "Points of Interest",
    COMMUNITY: "Communities"
  };

  useEffect(() => {
    // console.log(points,types,profileTypes);
    if (points && types && profileTypes) {
      var options = [];

      // const t0 = performance.now();

      var businessProfiles = [];
      var ambassadorProfiles = [];
      var poiProfiles = [];
      var communityProfiles = [];

      var usedProfileTypeStrings = [];

      var typeGroupSearchOptions = {};

      points.forEach((point, index) => {
        if (point.type === "USER_PROFILE") {
          var entry = {
            type: "POINT",
            label: point.userProfile.displayName,
            value: point.id
          };

          if (point.userProfile.userProfileType === "BUSINESS") {
            businessProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "POI") {
            poiProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "AMBASSADOR") {
            ambassadorProfiles.push(entry);
          } else if (point.userProfile.userProfileType === "COMMUNITY") {
            communityProfiles.push(entry);
          }
          usedProfileTypeStrings = usedProfileTypeStrings.concat(
            point.userProfile.types
          );
        }
      });

      // COUNTS
      setTypeCounts({
        AMBASSADOR: ambassadorProfiles.length,
        POI: poiProfiles.length,
        BUSINESS: businessProfiles.length,
        COMMUNITY: communityProfiles.length
      });

      // AMENITIES

      var theAmenities = usedAmenities(points);
      setAmenityOptions(theAmenities.map(am => am.value));
      var amenitySearch = theAmenities.map(function(am, index) {
        return buildOption("USER_PROFILE", am, { by: "AMENITY" });
      });

      // PROFILE TYPES

      var flattenedUsedProfileTypeStrings = [
        ...new Set([].concat([], usedProfileTypeStrings).flat())
      ];

      var usedProfileTypes = profileTypes.filter(pt =>
        flattenedUsedProfileTypeStrings.includes(pt.value)
      );

      var profileTypeSearch = [];

      var usedBusinessGroupTypes = [];
      nestedProfileTypes["BUSINESS"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: "BUSINESS"
            })
          );
          if (isSm) {
            profileTypeSearch.push({
              label: group.label,
              options: groupTypeSearch
            });
          } else {
            profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);
          }
          usedBusinessGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["BUSINESS"] = usedBusinessGroupTypes;

      var usedPoiGroupTypes = [];
      nestedProfileTypes["POI"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: "POI"
            })
          );
          if (isSm) {
            profileTypeSearch.push({
              label: group.label,
              options: groupTypeSearch
            });
          } else {
            profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);
          }
          usedPoiGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["POI"] = usedPoiGroupTypes;

      const usedAmbassadorGroupTypes = [];
      nestedProfileTypes["AMBASSADOR"].forEach((group, index) => {
        var usedInGroupProfileTypes = group.options.filter(pt =>
          flattenedUsedProfileTypeStrings.includes(pt.value)
        );
        if (usedInGroupProfileTypes.length > 0) {
          var groupTypeSearch = usedInGroupProfileTypes.map(function(
            pt,
            index
          ) {
            return buildOption("USER_PROFILE", pt, { by: "PROFILE_TYPE" });
          });
          var newGroup = { ...group };
          newGroup.label = `All ${newGroup.label}`;
          groupTypeSearch.unshift(
            buildOption("USER_PROFILE", newGroup, {
              by: "GROUP_TYPE",
              type: "AMBASSADOR"
            })
          );
          if (isSm) {
            profileTypeSearch.push({
              label: group.label,
              options: groupTypeSearch
            });
          } else {
            profileTypeSearch = profileTypeSearch.concat(groupTypeSearch);
          }
          usedAmbassadorGroupTypes.push(group.value);
        }
      });
      typeGroupSearchOptions["AMBASSADOR"] = usedAmbassadorGroupTypes;
      setTypeGroupOptions(typeGroupSearchOptions);

      options = options.concat(profileTypeSearch);

      if (businessProfiles.length > 0) {
        if (isSm) {
          options.push({ label: "Businesses", options: businessProfiles });
        } else {
          options = options.concat(businessProfiles);
        }
      }
      if (ambassadorProfiles.length > 0) {
        if (isSm) {
          options.push({ label: "Ambassadors", options: ambassadorProfiles });
        } else {
          options = options.concat(ambassadorProfiles);
        }
      }
      if (poiProfiles.length > 0) {
        if (isSm) {
          options.push({ label: "Points of Interest", options: poiProfiles });
        } else {
          options = options.concat(poiProfiles);
        }
      }
      if (communityProfiles.length > 0) {
        if (isSm) {
          options.push({ label: "Communities", options: communityProfiles });
        } else {
          options = options.concat(communityProfiles);
        }
      }
      if (amenitySearch.length > 0) {
        if (isSm) {
          options.push({ label: "Amenities", options: amenitySearch });
        } else {
          options = options.concat(amenitySearch);
        }
      }

      // const t1 = performance.now();
      // console.log(`Call to setFilterOptions took ${t1 - t0} milliseconds.`);

      setFilterOptions(options);

      if (types.length === 1) {
        setSelectedType(types[0]);
      }
    }
  }, [points, profileTypes, types]);

  useEffect(() => {
    if (textSearch && textSearch.length > 2) {
      var optionsToReturn = filterOptions.filter(
        opt => opt.label?.toLowerCase().indexOf(textSearch.toLowerCase()) > -1
      );
      if (optionsToReturn && optionsToReturn.length > 0) {
        var allResults = optionsToReturn.map(opt => {
          return filterPoints(opt);
        });
        var flattened = [...new Set([].concat([], allResults).flat())];
        // console.log(flattened);
        onSelect(flattened);
      } else {
        onSelect([]);
      }
    } else {
      onSelect(points);
    }
  }, [textSearch]);

  const usedAmenities = points => {
    var usedAmenityStrings = [];
    points.forEach((point, index) => {
      if (point.type === "USER_PROFILE") {
        usedAmenityStrings = usedAmenityStrings.concat(
          point.userProfile.amenities
        );
      }
    });
    var flattenedUsedAmenityStrings = [
      ...new Set([].concat([], usedAmenityStrings).flat())
    ];
    var usedAmenities = flattenedUsedAmenityStrings.map(val => {
      return amenities.find(am => am.value === val);
    });
    usedAmenities = usedAmenities.filter(am => am != null);
    return usedAmenities;
  };

  const buildOption = (type, category, filter) => {
    return {
      type: type,
      filter: filter,
      label: category.label,
      value:
        filter && filter.by === "AMENITY" ? [category.value] : category.value
    };
  };

  useEffect(() => {
    // console.log(
    //   "CommunityDirectoryPointFilter useEffect",
    //   selectedType,
    //   selectedSubtype,
    //   selectedAmenities,
    //   openNowCheck
    // );
    if (selectedType) {
      if (selectedSubtype) {
        var filteredPoints = filterPoints({
          type: "USER_PROFILE",
          filter: { by: "GROUP_TYPE", type: selectedType },
          value: selectedSubtype
        });

        if (selectedAmenities) {
          filteredPoints = filterPoints(
            {
              type: "USER_PROFILE",
              filter: { by: "AMENITY" },
              value: selectedAmenities
            },
            filteredPoints
          );
        } else {
          var theAmenities = usedAmenities(filteredPoints);
          setAmenityOptions(theAmenities.map(am => am.value));
        }
        if (openNowCheck && selectedType === "BUSINESS") {
          filteredPoints = openNowFilter(filteredPoints);
        }
        // console.log(filteredPoints);
        onSelect(filteredPoints);
      } else {
        var filteredPoints = filterPoints({
          type: "USER_PROFILE",
          filter: { by: "USER_PROFILE_TYPE" },
          value: selectedType
        });
        if (openNowCheck && selectedType === "BUSINESS") {
          filteredPoints = openNowFilter(filteredPoints);
        }
        // console.log(filteredPoints);
        onSelect(filteredPoints);
      }
    } else {
      // console.log("returning null to onSelect");
      onSelect(null);
    }
  }, [selectedType, selectedSubtype, selectedAmenities, openNowCheck]);

  const handleChange = selectedOptions => {
    setSelected(isSm ? selectedOptions : null);
    if (onSelect) {
      if (selectedOptions) {
        onSelect(filterPoints(selectedOptions));
      } else {
        onSelect(null);
      }
    }
  };

  const openNowFilter = filteredPoints => {
    var now = moment();
    return filteredPoints.filter(
      fp =>
        fp.userProfile &&
        fp.userProfile.location &&
        fp.userProfile.location.hours &&
        openNow(now, fp.userProfile.location.hours)
    );
  };

  const openNow = (now, openHours) => {
    var hoursObj = JSON.parse(openHours);
    // get today, time and day
    var utcOffset = moment.parseZone(now).utcOffset();
    var minutes = utcOffset * -1;
    var dow = now.format("dddd");
    var dowCaps = dow.toUpperCase();
    // find the object that contains the day
    // find the object that contains the day
    var dayObject = hoursObj.periods.find(
      period => period.open.day === dowCaps
    );
    if (dayObject && dayObject.open && dayObject.close) {
      // create the day from the name of the day
      var startOfDay = moment()
        .hours(dayObject.open.time.hour)
        .minutes(dayObject.open.time.minute);
      // .add(minutes, "minutes");
      var endOfDay = moment()
        .hours(dayObject.close.time.hour)
        .minutes(dayObject.close.time.minute);
      // .add(minutes, "minutes");
      if (endOfDay.hour() <= startOfDay.hour()) {
        endOfDay = endOfDay.add(1, "days");
      }
      if (now.isBetween(startOfDay, endOfDay)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const filterPoints = (searchFilter, existingFilter) => {
    // console.log("CommunityMapPointFilter filterPoints", searchFilter,existingFilter);
    // STORY, USER_PROFILE, EVENT
    // as an example, {type: "STORY", label: "Parkour", value: "play.outdoors.parkour"}
    // {type: "USER_PROFILE", label: "Cafe", value: "food.cafe"}
    // {type: "EVENT", label: "Literary", value: "cultural.literary"}

    var pointsToFilter = existingFilter ?? points;

    if (searchFilter == null) {
      return null;
    } else {
      if (searchFilter.type === "POINT") {
        return pointsToFilter.filter(point => point.id === searchFilter.value);
      } else {
        var filteredPoints = pointsToFilter.filter(
          point => point.type === searchFilter.type
        );
        if (filteredPoints.length > 0) {
          // console.log(filteredPoints);
          if (searchFilter.type === "USER_PROFILE") {
            if (searchFilter.filter.by === "PROFILE_TYPE") {
              filteredPoints = filteredPoints.filter(
                fp =>
                  fp.userProfile.types.findIndex(
                    typ => typ === searchFilter.value
                  ) > -1
              );
            } else if (searchFilter.filter.by === "AMENITY") {
              filteredPoints = filteredPoints.filter(
                fp =>
                  fp.userProfile.amenities.findIndex(am =>
                    searchFilter.value.includes(am)
                  ) > -1
              );
            } else if (searchFilter.filter.by === "GROUP_TYPE") {
              var group = nestedProfileTypes[searchFilter.filter.type].find(
                gp => gp.value === searchFilter.value
              );
              if (group) {
                var allGroupTypes = group.options.map(opt => opt.value);
                filteredPoints = filteredPoints.filter(
                  fp =>
                    fp.userProfile.types.filter(value =>
                      allGroupTypes.includes(value)
                    ).length > 0
                );
              }
            } else if (searchFilter.filter.by === "USER_PROFILE_TYPE") {
              filteredPoints = filteredPoints.filter(
                fp => fp.userProfile.userProfileType === searchFilter.value
              );
            }
          }
          return filteredPoints;
        }
      }
    }
  };

  const formatGroupLabel = data => (
    <div>
      <h4>{data.label}</h4>
    </div>
  );

  const typeLabel = (type, clickable) => {
    var count = typeCounts[type];

    return (
      <div className={`type-label with-icon${clickable ? " clickable" : ""}`}>
        <ProfileTypeIcon type={type} />
        <h4 style={{ marginBottom: 0 }}>
          {typeToLabel[type]} ({count})
        </h4>
      </div>
    );
  };

  const ValueContainer = ({ children, ...props }) => {
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && (
            <span className="material-icons" style={{ color: "#CCCCCC" }}>
              search
            </span>
          )}
          {children}
        </components.ValueContainer>
      )
    );
  };

  const searchFilterStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    placeholder: base => ({
      ...base,
      paddingLeft: 24
    }),
    singleValue: base => ({
      ...base,
      paddingLeft: 24
    })
  };

  return (
    <>
      {isSm ? (
        <>
          <Select
            menuPortalTarget={document.body}
            styles={{
              ...searchFilterStyles,
              menuPortal: base => ({ ...base, zIndex: 9999 })
            }}
            className="select"
            classNamePrefix="select"
            components={{
              // DropdownIndicator: () => null,
              // IndicatorSeparator: () => null,
              ValueContainer
            }}
            isMulti={false}
            isSearchable={true}
            isClearable={true}
            options={filterOptions}
            value={selected}
            onChange={handleChange}
            placeholder="Search directory"
            formatGroupLabel={formatGroupLabel}
            openMenuOnClick={true}
            blurInputOnSelect={true}
          />
        </>
      ) : (
        <>
          <div className="community-directory-map-point-filter-v2">
            <div className="search">
              <div className="select">
                <TextSearchInputField
                  onChange={text => {
                    setTextSearch(text);
                  }}
                  placeholder="Search directory"
                />
              </div>
            </div>
            <div className="type-labels-and-counts">
              {types.length > 1 ? (
                <>
                  {types.map((type, index) => {
                    if (typeCounts[type] > 0) {
                      return (
                        <Fragment key={index}>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedType(type);
                              setSelectedSubtype(null);
                            }}
                          >
                            {typeLabel(type, true)}
                          </div>
                          <Collapse in={type === selectedType}>
                            <div>
                              {showOpenNow && selectedType === "BUSINESS" && (
                                <Form.Check
                                  className={openNowCheck ? "checked" : ""}
                                  custom="true"
                                  type="switch"
                                  checked={openNowCheck}
                                  id="active"
                                  name="active"
                                  onChange={evt => {
                                    var enabled = evt.target.checked;
                                    setOpenNowCheck(enabled);
                                  }}
                                  label="Open Now"
                                />
                              )}
                              <ProfileTypeFilterv2
                                values={typeGroupOptions[selectedType]}
                                onChange={selected => {
                                  // console.log("CommunityDirectoryPointFilter ProfileTypeFilter onChange", selected);
                                  setSelectedType(type);
                                  setSelectedSubtype(
                                    selected ? selected.value : null
                                  );
                                }}
                                renderAll={false}
                              />
                            </div>
                          </Collapse>
                        </Fragment>
                      );
                    } else {
                      return null;
                    }
                  })}
                </>
              ) : (
                <div className={"default-flex-column-layout"}>
                  {showOpenNow && selectedType === "BUSINESS" && (
                    <Form.Check
                      className={openNowCheck ? "checked" : ""}
                      custom="true"
                      type="switch"
                      checked={openNowCheck}
                      id="active"
                      name="active"
                      onChange={evt => {
                        var enabled = evt.target.checked;
                        setOpenNowCheck(enabled);
                      }}
                      label="Open Now"
                    />
                  )}
                  {selectedType && (
                    <ProfileTypeFilterv2
                      values={typeGroupOptions[selectedType]}
                      onChange={selected => {
                        // console.log("CommunityDirectoryPointFilter ProfileTypeFilter onChange", selected);
                        setSelectedSubtype(selected ? selected.value : null);
                      }}
                      renderAll={false}
                    />
                  )}
                </div>
              )}

              <Collapse
                in={
                  selectedType && selectedSubtype && amenityOptions.length > 0
                }
              >
                <div>
                  <h4 style={{ marginBottom: "1rem" }}>Amenities</h4>
                  <AmenityFilter
                    scrollable={isSm}
                    iconSize="sm"
                    stacked={false}
                    vertical={true}
                    values={amenityOptions}
                    multiple={true}
                    onSelect={selected => setSelectedAmenities(selected)}
                  />
                </div>
              </Collapse>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default CommunityDirectoryPointFilterv2;
